<template>
    <div class="header-box">
        <div class="header">
            <img class="md:w-[221px] w-[130px] aspect-[221/76]" src="/images/jhma-header-logo.png" alt="JHMA"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "Header"
}
</script>

<style scoped>

</style>
